import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, FormControl, FormHelperText, TextField } from '@mui/material';
import { Row, Col } from 'react-bootstrap';

export default function AutocompleteInput(props) {
  const { errors, selectOptions, id, variant, onChange, value, refValue, disabled, defaultValue } = props;

  return (
    <Row>
      <Col xs={12}>
        <FormControl fullWidth variant={variant || 'filled'} error={!!errors}>
          <Autocomplete
            ref={refValue}
            id={id}
            value={value}
            defaultValue={defaultValue}
            options={selectOptions}
            disabled={disabled}
            getOptionDisabled={() => disabled}
            onChange={(event, newValue) => {
              if (newValue === null) {
                onChange('');
              }
              else {
                onChange(newValue.value);
              }
            }}
            getOptionLabel={(option) => option.label || option.text || ''}
            renderInput={(params) => <TextField {...params} label={props.label} variant={variant || 'filled'} />}
          />
          <FormHelperText>{errors && errors.message}</FormHelperText>
        </FormControl>
      </Col>
    </Row>
  );
}

AutocompleteInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.any,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  variant: PropTypes.string,
  errors: PropTypes.object,
  refValue: PropTypes.any,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.any,
};
